// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteModels {
    static getAttributeTypeMap() {
        return SiteModels.attributeTypeMap;
    }
}
SiteModels.discriminator = undefined;
SiteModels.additionalProperties = false;
SiteModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<SiteModel>"
    },
];
//# sourceMappingURL=siteModels.js.map